import { AnalyticsProvider, MasterPage as MasterPageShared, useOidcAuthentication } from '@cp-shared-19/frontend-ui';
import { IconFooter as IconFooterUi } from 'components/icon-footer';
import { identificationPagePath, loginInProgressPagePath } from 'components/navigation/paths';
import { currentBrand } from 'config/config';
import React, { useEffect } from 'react';
import { LegalFooter } from '../components/legal-footer';
import { NavigationBar } from '../components/navigation/NavigationBar';
import { useHistory } from 'react-router-dom';
import { getErrorPagePathWithErrorType } from 'auth';
import { useForceLogin } from '../hooks';

// eslint-disable-next-line @typescript-eslint/ban-types
export type MasterPageProps = {};

export const MasterPage: React.FC<MasterPageProps> = ({ children }) => {
    const { isAuthenticated, urlError } = useOidcAuthentication();
    const history = useHistory();
    useForceLogin();

    useEffect(() => {
        if (urlError) {
            history.push(getErrorPagePathWithErrorType(urlError));
        }
    }, [urlError]);

    return (
        <AnalyticsProvider
            market={'nl'}
            isAuthenticated={isAuthenticated}
            version={'1'}
            releaseDate={'2021-01-25'}
            language={'nl'}
            registrationPath={identificationPagePath()}
            loginPath={loginInProgressPagePath()}
            userGroup={'private'}
            brand={currentBrand}
        >
            <MasterPageShared
                navigationBar={<NavigationBar />}
                iconFooter={<IconFooterUi />}
                legalFooter={<LegalFooter />}
            >
                {children}
            </MasterPageShared>
        </AnalyticsProvider>
    );
};
